import type { PointOfInterest } from "../../@types/mapviewxs";
import { type HorizontalPosition, type PreviewCardPosition, type VerticalPosition, getPreviewCardPosition } from "../../utils/preview-card-position";
import type { ItemCardControls, MapAccessibilityTexts, MarkerSelectionState, MarkerWithCircle } from "../map/types";

export interface Input {
  selectionState?: MarkerSelectionState;
  animationDelay?: number;
  itemCardControls?: ItemCardControls;
  itemCards?: PointOfInterest[];
  onPreviewClose?: () => void;
  defaultPreviewPosition?: PreviewCardPosition;
  selectedMarker?: MarkerWithCircle | null;
  isPreviewCardEnabled?: boolean;
  mapAccessibilityTexts?: MapAccessibilityTexts;
}

export interface State {
  previewVerticalPosition?: VerticalPosition | null;
  previewHorizontalPosition?: HorizontalPosition | null;
  itemIndex: number;
}

export default class extends Marko.Component<Input, State> {
  onCreate() {
    this.state = {
      itemIndex: 0,
      previewVerticalPosition: null,
      previewHorizontalPosition: null,
    };
  }

  onRender() {
    if (this.input?.defaultPreviewPosition) {
      const { verticalPosition, horizontalPosition } = this.input.defaultPreviewPosition;
      this.state.previewVerticalPosition = verticalPosition;
      this.state.previewHorizontalPosition = horizontalPosition;
    }
  }

  onInput(input: Input) {
    this.updatePreviewPosition(input, input.selectedMarker?.component.el);
  }

  onUpdate() {
    this.updatePreviewPosition(this.input, this.el);
  }

  updatePreviewPosition(input: Input, markerElement?: Element | void) {
    const isItemSelected = input.selectionState === "selected";
    const mapElement = document.querySelector("#map");
    const previewItemElement = markerElement?.querySelector(".preview-item");

    if (isItemSelected && markerElement && mapElement && previewItemElement && !this.state?.previewVerticalPosition) {
      const { verticalPosition, horizontalPosition } = getPreviewCardPosition(mapElement, markerElement, previewItemElement);
      this.state = {
        itemIndex: 0,
        previewVerticalPosition: verticalPosition,
        previewHorizontalPosition: horizontalPosition,
      };
    } else if (!isItemSelected) {
      this.state = {
        itemIndex: 0,
      };
    }
  }

  onPreviousItem() {
    this.state.itemIndex--;
  }

  onNextItem() {
    this.state.itemIndex++;
  }

  onPreviewClose() {
    this.state.itemIndex = 0;
    this.input.onPreviewClose?.();
  }
}
